<template>
  <ChatSettingForm />
</template>

<script>
import ChatSettingForm from '../../SmartScheduling/components/ChatSettingForm.vue'
export default {
  components: {
    ChatSettingForm
  }
}
</script>
